import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Check, Sparkles, ArrowUpRight } from "lucide-react";
import { PlanDef } from "./plans-data";

interface Props {
  plan: PlanDef;
  price: number;
  billingCycle: "monthly" | "yearly";
  isCurrentPlan: boolean;
  isTrial: boolean;
  hasSubscription: boolean;
  onSelect: (id: string) => void;
}

const PlanCard = ({ plan, price, billingCycle, isCurrentPlan, isTrial, hasSubscription, onSelect }: Props) => {
  const Icon = plan.icon;

  return (
    <Card
      className={`relative transition-all hover:shadow-lg ${plan.popular ? "ring-2 ring-primary shadow-md scale-[1.02]" : ""} ${plan.color} ${isCurrentPlan ? "opacity-80" : ""}`}
    >
      {plan.popular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2">
          <Badge className="bg-primary text-primary-foreground shadow-sm flex items-center gap-1">
            <Sparkles className="w-3 h-3" />
            الأكثر طلباً
          </Badge>
        </div>
      )}
      {plan.badge && (
        <div className="absolute top-3 right-3">
          <Badge variant="outline" className="text-[10px] font-normal">
            {plan.badge}
          </Badge>
        </div>
      )}
      <CardHeader className="text-center pb-2 pt-8">
        <div className="mx-auto mb-3 w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center">
          <Icon className="w-7 h-7 text-primary" />
        </div>
        <CardTitle className="text-xl">{plan.name}</CardTitle>
        <p className="text-xs text-muted-foreground font-medium tracking-wide">{plan.subtitle}</p>
        <div className="mt-3">
          <span className="text-3xl font-bold">{price.toLocaleString()}</span>
          <span className="text-sm text-muted-foreground mr-1">
            ج.م / {billingCycle === "yearly" ? "سنة" : "شهر"}
          </span>
          {billingCycle === "yearly" && (
            <p className="text-xs text-muted-foreground line-through mt-1">
              {(plan.monthlyPrice * 12).toLocaleString()} ج.م / سنة
            </p>
          )}
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <ul className="space-y-2">
          {plan.features.map((feature, i) => (
            <li key={i} className="flex items-start gap-2 text-sm">
              <Check className="w-4 h-4 text-green-600 shrink-0 mt-0.5" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <Button
          className="w-full"
          variant={isCurrentPlan ? "outline" : plan.popular ? "default" : "outline"}
          disabled={isCurrentPlan}
          onClick={() => onSelect(plan.id)}
        >
          {isCurrentPlan ? (
            "خطتك الحالية"
          ) : (
            <span className="flex items-center gap-1.5">
              {isTrial || !hasSubscription ? "اشترك الآن" : "ترقية"}
              <ArrowUpRight className="w-4 h-4" />
            </span>
          )}
        </Button>
      </CardContent>
    </Card>
  );
};

export default PlanCard;
